// extracted by mini-css-extract-plugin
export default {"ScheduleTabs":"ScheduleTabs-module-a2d3196319e97f455727","labeled":"ScheduleTabs-module-e8f593c6e59c2e1038a4","selected":"ScheduleTabs-module-afca3cb11f712cd6883f"};